import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSeeMoreIconProps extends SvgIconProps {}
/**
 * component used to display see more icon in twitter interaction
 * @param props - CcfSeeMoreIconProps
 * @example - <CcfSeeMoreIcon />
 * @returns SVG of see more icon in twitter interaction
 */
export function CcfSeeMoreIcon(props: CcfSeeMoreIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="see_more_tweets" clip-path="url(#clip-see_more_tweets)">
        <path id="Path_25527" data-name="Path 25527" d="M0,7.737,10.921,0,21.842,7.737" transform="translate(23.342 20.277) rotate(180)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5"/>
        <path id="Path_25528" data-name="Path 25528" d="M0,7.737,10.921,0,21.842,7.737" transform="translate(23.342 11.793) rotate(180)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5"/>
      </g>
    </SvgIcon>
  );
}

export default CcfSeeMoreIcon;
